import { combineReducers } from 'redux'
import { invoices } from './account'
import { smallView, currentView } from './view'

export default combineReducers({
    smallView,
    currentView,
    invoices
})
